import React from "react";
import { useTranslation } from "react-i18next";

const TermsAndConditions = ({ latestMission, longDescription }) => {
  const { t } = useTranslation();
const seniorLayout = localStorage.getItem("seniorLayout") === "true";


  if (!latestMission) {
    return null;
  }

  return (
    <div className="bg-white p-4 rounded-lg shadow-md text-left mt-4">
      <div className="w-full flex flex-col gap-y-2">
        <div className="w-full">
          <div
            className={`font-semibold ${seniorLayout ? "text-lg" : "text-xl"}`}
          >
            {t("coupon_redemption_period")}
          </div>
          <div
            className={`font-normal ${seniorLayout ? "text-lg" : "text-sm"}`}
          >
            {new Date(latestMission.startDate).toLocaleDateString("th-TH")} -{" "}
            {new Date(latestMission.endDate).toLocaleDateString("th-TH")}
          </div>
          <br />
          <div
            className={`font-semibold ${seniorLayout ? "text-lg" : "text-xl"}`}
          >
            {t("terms_and_conditions")}
          </div>

          <div
            className={`font-normal ${seniorLayout ? "text-lg" : "text-sm"}`}
          >
            {Array.isArray(longDescription) &&
              longDescription.map((text, index) => (
                <div key={index} className="mb-3">
                  {" "}
                  {/* mb-3 ทำให้เว้นบรรทัดห่างขึ้น */}
                  {text}
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
